module.exports = __webpack_public_path__ + "static/section-5-img-2@2x-8b0acf6085d93d4b44dfdda3738ffcef.png";